// src/pages/Impressum.tsx
import { Layout } from '@/components/Layout';

export default function Impressum() {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-16 max-w-3xl">
        <h1 className="text-3xl font-bold mb-2">Impressum</h1>
        <p className="text-muted-foreground text-sm mb-10">Angaben gemäß § 5 TMG</p>

        <div className="space-y-8 text-sm leading-relaxed text-foreground">

          <section>
            <h2 className="font-bold text-base mb-2">Anbieter</h2>
            <p>
              Jonas Huber<br />
              Ferdinand-Wallbrecht-Straße 55<br />
              30163 Hannover<br />
              Deutschland
            </p>
          </section>

          <section>
            <h2 className="font-bold text-base mb-2">Kontakt</h2>
            <p>
              Telefon: 0163 674 333 2<br />
              E-Mail: <a href="mailto:kontakt@salesforge.de" className="text-primary underline">kontakt@salesforge.de</a>
            </p>
          </section>

          <section>
            <h2 className="font-bold text-base mb-2">Registereintrag</h2>
            <p>
              Handelsregister: Amtsgericht Berlin (Charlottenburg)<br />
              Registernummer: HRB 123456 B<br />
            </p>
          </section>

          <section>
            <h2 className="font-bold text-base mb-2">Umsatzsteuer-ID</h2>
            <p>
              Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:<br />
              DE 123456789
            </p>
          </section>

          <section>
            <h2 className="font-bold text-base mb-2">Verantwortlich für den Inhalt</h2>
            <p>
              Jonas Huber<br />
              Ferdinand-Wallbrecht-Straße 55, 30163 Hannover
            </p>
          </section>

          <section>
            <h2 className="font-bold text-base mb-2">EU-Streitbeilegung</h2>
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary underline"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p className="mt-2">
              Unsere E-Mail-Adresse finden Sie oben im Impressum. Wir sind nicht bereit und nicht
              verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
              teilzunehmen. Das Angebot richtet sich ausschließlich an Unternehmer im Sinne des § 14 BGB.
            </p>
          </section>

          <section>
            <h2 className="font-bold text-base mb-2">Haftungshinweis</h2>
            <p>
              Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte
              externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber
              verantwortlich.
            </p>
          </section>

        </div>
      </div>
    </Layout>
  );
}
